// extracted by mini-css-extract-plugin
module.exports = {"questions":"ProfileMyQuestions_questions__36ZqD","questionCard":"ProfileMyQuestions_questionCard__ezn1F","showMoreBtn":"ProfileMyQuestions_showMoreBtn__3fmLg"};